import type { AppLocale } from '../services/locale/locale.service';

/**
 * Pick the Danish or English variant of a field based on the current locale.
 * Falls back to the English value when Danish is absent or locale is English.
 *
 * Works with both `AppLocale` ('da') and `ImportLanguage` ('DA') casing.
 */
export function localizedField(
  en: string | null | undefined,
  da: string | null | undefined,
  locale: AppLocale | string
): string {
  if (locale.toLowerCase() === 'da' && da) return da;
  return en ?? '';
}
